import PropTypes from 'prop-types';
import React from "react";
import cx from "classnames";
import {

  Col,
  Image,
  Row,

} from "react-bootstrap";
import Tooltip from '../../../../../../components/tooltip';

import styles from "./Styles.module.scss";
import _ from "lodash";
import { localizedStrings } from '../../../../../../localization';
import Salesforce from "../../../../../images/integrations/salesforce.svg";
import MSDynamics from "../../../../../images/integrations/msDynamics.png";
import Text from 'src/components/text';

class CustomFieldItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: false
    }

    this._handleSelection = this._handleSelection.bind(this);
    this._handleDelete = this._handleDelete.bind(this);

    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedCustomFields = this.localizedSettings.account.custom_fields;
  }

  componentDidMount() {}

  _handleSelection() {
    if (this.props.onSelection) {
      this.props.onSelection(this.props.item);
    }
  }


  _handleDelete() {
    this.props.onDelete(this.props.item);
  }

  _getIntegrationIcon(type) {
    switch (type) {
      case "salesforce_v2":
        return Salesforce;
      case "ms_dynamics_v2":
        return MSDynamics;
      default:
        return "";
    }
  }

  _getIntegrationType(type) {
    switch (type) {
      case "salesforce_v2":
        return "Salesforce";
      case "ms_dynamics_v2":
        return "MS Dynamics";
      default:
        return "";
    }
  }

  render() {
    return (
      <Row
        key={this.props.index}
     
        className={cx(
          styles.item,
          { [styles.selected]: _.get(this.props, "selected.id") === _.get(this.props, "item.id") },
          { [styles.creating]: this.props.creating }
        )}
        onClick={() => this._handleSelection()}
      >
        <Col md={10} xl={10} lg={10} className={styles.name}>
          <Text text={_.get(this.props,"item.name")} />
        </Col>

        {!this.props.creating && !_.isEmpty(this.props.item.integrationType) && (
          <Col md={1} lg={1} xl={1} className={styles.actions}>
            <Tooltip content={this._getIntegrationType(this.props.item.integrationType) + this.localizedCustomFields.opportunity_field}>
              <Image className={styles.integrationIcon} src={this._getIntegrationIcon(this.props.item.integrationType)} />
            </Tooltip>
          </Col>
        )}

        {!this.props.creating && _.isEmpty(this.props.item.integrationType) && (
          <Col md={1} lg={1} xl={1} className={styles.actions}>
            <Tooltip content={this.localizedCustomFields.tooltip.delete}>
              <div className={styles.action} onClick={this._handleDelete}>
                <i className="paperflite-delete"></i>
              </div>
            </Tooltip>

          </Col>
        )}
      </Row>
    );
  }
}

CustomFieldItem.contextTypes = {
  selection: PropTypes.object,
};

export default CustomFieldItem;
